/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grassy_Wise_Chicken_TwirlInputs */

const fr_grassy_wise_chicken_twirl = /** @type {(inputs: Grassy_Wise_Chicken_TwirlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min (kg)`)
};

/**

* @param {Grassy_Wise_Chicken_TwirlInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const grassy_wise_chicken_twirl = /** @type {((inputs?: Grassy_Wise_Chicken_TwirlInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grassy_Wise_Chicken_TwirlInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_grassy_wise_chicken_twirl(inputs)
});